import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GdprPrivacyDirective } from 'shared/gdpr-privacy/gdpr-privacy.directive';
import { GdprPrivacyPipe } from 'shared/gdpr-privacy/gdpr-privacy.pipe';

@NgModule({
    declarations: [GdprPrivacyDirective, GdprPrivacyPipe],
    imports: [CommonModule],
    // gdprPrivacyService provided in root, singleton service for the whole application
    exports: [GdprPrivacyDirective, GdprPrivacyPipe],
})
export class GdprPrivacyModule {}
